module.exports = __webpack_public_path__ + "static/media/close.79206426.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.png
// module id = 203
// module chunks = 0